import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartType, ChartOptions } from 'chart.js';
import { MasterService } from '../../../@core/services/master.service';
import { RoleService } from '../../../@core/services/role.service';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'ngx-analysis-manager',
  templateUrl: './analysis-manager.component.html',
  styleUrls: ['./analysis-manager.component.scss']
})
export class AnalysisManagerComponent implements OnInit {
  @ViewChild('completionChart') completionChart?: BaseChartDirective;
  
  userRole: any;
  metrics: { projects: any; parts: any; openProjects: any; totalValue: string; } = {
    projects: 0,
    parts: 0,
    openProjects: 0,
    totalValue: '0'
  };
  project_id: any = null;
  version_id: any = null;
  isRefreshing: boolean = false;
   constructor(private f_builder: FormBuilder,
               private router: Router,
               private modalService: NgbModal,
               private masterService: MasterService,
               private notify: NbToastrService,private roleService: RoleService, 
               ) { }

  // Ageing Chart
  ageingChartData = {
    labels: ['0-5 Days', '5-8 Days', '8-10 Days', '>10'],
    datasets: [
      {
        data: [3, 2, 1, 1],
        label: 'Series 1',
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Completion Chart - using <50%, 50-75%, >75% labels
  completionChartData = {
    labels: ['<50%', '50-75%', '>75%'],
    datasets: [
      {
        data: [2, 2, 1],
        backgroundColor: [
          'rgba(255, 99, 132, 0.8)',
          'rgba(255, 159, 64, 0.8)',
          'rgba(75, 192, 192, 0.8)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(255, 159, 64, 1)',
          'rgba(75, 192, 192, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Cost Chart
  // costChartData = {
  //   labels: ['Credit', 'Advance', 'COD'],
  //   datasets: [
  //     {
  //       data: [64, 25, 11],
  //       backgroundColor: [
  //         'rgba(54, 162, 235, 0.8)',
  //         'rgba(255, 159, 64, 0.8)',
  //         'rgba(255, 99, 132, 0.8)',
  //       ],
  //       borderColor: [
  //         'rgba(54, 162, 235, 1)',
  //         'rgba(255, 159, 64, 1)',
  //         'rgba(255, 99, 132, 1)',
  //       ],
  //       borderWidth: 1,
  //     },
  //   ],
  // };
  costChartData = {
  labels: [] as string[],
  datasets: [
    {
      data: [] as number[],
      backgroundColor: [] as string[],
      borderColor: [] as string[],
      borderWidth: 1
    }
  ]
};

  // Engineer-wise Chart
  engineerChartData = {
    labels: ['Guna', 'Shiva', 'Maya'],
    datasets: [
      {
        label: 'Closed',
        data: [15, 10, 8],
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
      {
        label: 'Open',
        data: [8, 5, 3],
        backgroundColor: 'rgba(255, 159, 64, 0.8)',
        borderColor: 'rgba(255, 159, 64, 1)',
        borderWidth: 1,
      },
      {
        label: 'Total',
        data: [23, 15, 11],
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Import Status Chart
  // importStatusData = {
  //   labels: ['Mechanical parts', 'Conn Brems', 'C & T', 'C & W', 'Connectors'],
  //   datasets: [
  //     {
  //       label: 'Local',
  //       data: [250000, 180000, 120000, 150000, 200000],
  //       backgroundColor: 'rgba(255, 99, 132, 0.8)',
  //       borderColor: 'rgba(255, 99, 132, 1)',
  //       borderWidth: 1,
  //     },
  //     {
  //       label: 'Import',
  //       data: [150000, 100000, 80000, 90000, 120000],
  //       backgroundColor: 'rgba(54, 162, 235, 0.8)',
  //       borderColor: 'rgba(54, 162, 235, 1)',
  //       borderWidth: 1,
  //     },
  //   ],
  // };

  // Shared Options
  chartOptions: any = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 16,
          font: {
            size: 12,
            weight: '600',
            family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#64748b',
          boxWidth: 8,
          boxHeight: 8
        }
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(15, 20, 25, 0.95)',
        padding: 14,
        titleFont: { size: 13, weight: 'bold' as any, family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
        bodyFont: { size: 12, family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
        cornerRadius: 8,
        displayColors: true,
        boxPadding: 8
      }
    },
    scales: {
      x: {
        barPercentage: 0.65,
        categoryPercentage: 0.60,
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          font: { size: 11, weight: 500 as any },
          color: '#64748b'
        },
        grid: {
          color: 'rgba(30, 41, 59, 0.05)',
          drawBorder: false,
          display: true
        }
      },
      y: {
        ticks: {
          font: { size: 11, weight: 500 as any },
          color: '#64748b',
          callback: function(value: any) {
            if (value >= 10000000) {
              return (value / 10000000).toFixed(1) + 'Cr';
            } else if (value >= 1000000) {
              return (value / 1000000).toFixed(1) + 'M';
            } else if (value >= 1000) {
              return (value / 1000).toFixed(1) + 'K';
            }
            return value;
          }
        },
        grid: {
          color: 'rgba(30, 41, 59, 0.05)',
          drawBorder: false,
          display: true
        }
      }
    },
    animation: {
      duration: 800,
      easing: 'easeInOutQuart'
    }
  };


  chartLegend = true;

  // Chart options without grids (for doughnut charts)
  chartOptionsNoGrid: any = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 16,
          font: {
            size: 12,
            weight: '600',
            family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#64748b',
          boxWidth: 8,
          boxHeight: 8,
          cursor: 'pointer'
        }
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(15, 20, 25, 0.95)',
        padding: 14,
        titleFont: { size: 13, weight: 'bold' as any, family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
        bodyFont: { size: 12, family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
        cornerRadius: 8,
        displayColors: true,
        boxPadding: 8
      }
    },
    scales: {
      x: {
        display: false,
        grid: {
          display: false
        }
      },
      y: {
        display: false,
        grid: {
          display: false
        }
      }
    },
    animation: {
      duration: 800,
      easing: 'easeInOutQuart'
    }
  };

  // Horizontal bar chart options for Cost chart (like Payment Terms Distribution)
  paymentTermsChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    barPercentage: 0.7,
    categoryPercentage: 0.9,
    
    plugins: {
      legend: {
        display: false
      },
      datalabels: {
        color: '#ffffff',
        anchor: 'end',
        align: 'right',
        offset: 8,
        clamp: true,
        clip: false,
        font: {
          weight: '700',
          size: 11,
          family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        formatter: (value: number) => {
          if (!value) return '';
          if (value >= 1000000) return '₹ ' + (value / 1000000).toFixed(2) + 'M';
          if (value >= 100000) return '₹ ' + (value / 100000).toFixed(2) + 'L';
          if (value >= 1000) return '₹ ' + (value / 1000).toFixed(1) + 'K';
          return '₹ ' + value.toString();
        }
      },
      tooltip: {
        backgroundColor: 'rgba(15, 20, 25, 0.95)',
        titleFont: {
          size: 13,
          weight: 'bold',
          family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        bodyFont: {
          size: 12,
          family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        padding: 14,
        cornerRadius: 8,
        displayColors: true,
        boxPadding: 8,
        titleColor: '#fff',
        bodyColor: '#fff',
        callbacks: {
          label: (ctx: any) => {
            const val = ctx.raw ?? 0;
            const formatted = val >= 1000000 
              ? (val / 1000000).toFixed(2) + 'M'
              : val >= 100000 
              ? (val / 100000).toFixed(2) + 'L'
              : val >= 1000 
              ? (val / 1000).toFixed(1) + 'K'
              : val.toString();
            return `Amount: ₹ ${formatted}`;
          }
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        stacked: false,
        ticks: {
          font: {
            size: 11,
            weight: '500'
          },
          color: '#64748b',
          callback: (value: any) => {
            if (value >= 1000000) return (value / 1000000).toFixed(1) + 'M';
            if (value >= 100000) return (value / 100000).toFixed(1) + 'L';
            if (value >= 1000) return (value / 1000).toFixed(0) + 'K';
            return value;
          }
        },
        grid: {
          color: 'rgba(30, 41, 59, 0.08)',
          drawBorder: false,
          display: true,
          drawTicks: false
        },
        border: {
          display: false
        }
      },
      y: {
        ticks: {
          font: {
            size: 12,
            weight: '600'
          },
          color: '#2d3748',
          maxRotation: 0,
          minRotation: 0
        },
        grid: {
          display: false,
          drawBorder: false
        },
        border: {
          display: false
        }
      }
    }
  };

  // Pagination variables
  itemsPerTable = 6;

  get masterDataDisplayList(): any[] {
    return this.masterDataList.slice(0, this.itemsPerTable);
  }

  get partDeviationDisplayList(): any[] {
    return this.partDeviationList.slice(0, this.itemsPerTable);
  }

home() {
  this.router.navigate(['/dashboard-manager'], {
    state: { fromAnalysisManager: true }
  });
}

navigateToOpenProjects() {
  console.log('Navigating to dashboard-manager with Open projects filter');
  this.router.navigate(['/dashboard-manager'], {
    state: { 
      filterType: 'open',
      filterStatus: 'Open',
      fromAnalysisManager: true
    }
  });
}

navigateToAllProjects() {
  console.log('Navigating to dashboard-manager to show all projects');
  this.router.navigate(['/dashboard-manager'], {
    state: { 
      filterType: 'all',
      fromAnalysisManager: true
    }
  });
}

navigateToCompletionFilter(completionRange: string) {
  console.log('Navigating to dashboard-manager with completion filter:', completionRange);
  this.router.navigate(['/dashboard-manager'], {
    state: { 
      filterType: 'completion',
      completionRange: completionRange,
      fromAnalysisManager: true
    }
  });
}

navigateToLessThan50() {
  this.navigateToCompletionFilter('lt50');
}

navigateToFiftyTo75() {
  this.navigateToCompletionFilter('50to75');
}

navigateToGreaterThan75() {
  this.navigateToCompletionFilter('gt75');
}

// Handle direct chart segment clicks (like source-pulse)
onCompletionChartClick(event: any): void {
  if (event.active && event.active.length > 0) {
    const clickedIndex = event.active[0].index;
    const categories = ['lt50', '50to75', 'gt75'];
    const categoryKey = categories[clickedIndex];
    
    // Navigate based on clicked segment
    if (categoryKey === 'lt50') {
      this.navigateToLessThan50();
    } else if (categoryKey === '50to75') {
      this.navigateToFiftyTo75();
    } else if (categoryKey === 'gt75') {
      this.navigateToGreaterThan75();
    }
  }
}

// Navigate to project-view with part highlighting
navigateToPartInProjectView(event: any, partNumber: string): void {
  // Prevent default behavior and stop propagation
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  // Navigate to project-view and highlight the specific part
  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
  const projectId = Number(sessionStorage.getItem('project_id'));
  const versionId = Number(sessionStorage.getItem('version_id'));
  
  console.log('🔵 Navigating to part in project-view:', {
    partNumber,
    projectId,
    versionId
  });
  
  this.router.navigate(['/project-view'], {
    state: { 
      project_id: projectId,
      version_id: versionId,
      highlightedPartNo: partNumber,
      scrollToHighlight: true,
      selectedTabIndex: 1, // SUPPLY SENSE tab
      fromAnalysisManager: true
    }
  }).then(success => {
    if (success) {
      console.log('✅ Navigation successful');
    } else {
      console.error('❌ Navigation failed');
    }
  });
}

refresh(): void {
  this.isRefreshing = true;
  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
  const payload = {
    manager_id: currentUser.manager_id ?? currentUser.user_id,
    // engineer_id: currentUser.engineer_id ?? null,
  };

  this.loadDashboard(payload);
  this.loadAgeingSummary(payload);
  this.loadCompletionSummary();
  // this.loadImportStatus();
  this.loadDashboards(payload);
  this.loadMasterData();
  this.loadCostSavings();

  this.isRefreshing = false;
  this.notify.success('Dashboard refreshed successfully', 'Success');
}

ngOnInit(): void {
        this.userRole = this.roleService.getUserRole();
    console.log('Source Pulse initialized with sample data');
   const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');


const payload = {
  manager_id: currentUser.manager_id ?? currentUser.user_id,
  // engineer_id: currentUser.engineer_id ,
 
};

console.log('Dashboard payload =>', payload);


this.loadDashboard(payload);
this.loadAgeingSummary(payload);
  this.loadCompletionSummary();
// this.loadImportStatus();  
this.loadDashboards(payload)
this.loadMasterData();
this.loadMasterDataStatus();
this.loadPartPricingSummary();
this.loadSmartSyncSummary();
this.loadSupplierPaymentSummary();
this.loadCostSavings();
  }
loadDashboards(payload: any) {

  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

  const params: any = {
    manager_id: payload?.manager_id ?? currentUser.manager_id ?? currentUser.user_id
  };

  // Add date filter parameters if set
  if (this.engineerStartDate) {
    params['start_date'] = this.engineerStartDate;
  }
  if (this.engineerEndDate) {
    params['end_date'] = this.engineerEndDate;
  }

  console.log('Engineer-wise params =>', params);

  this.masterService
    .getEngineerWiseProjectSummary(params.manager_id)
    .subscribe((res: any) => {

      const engineers = res.engineers || [];

      const labels = engineers.map((x: any) => x.engineer_name);
      const closedData = engineers.map((x: any) => x.closed);
      const openData   = engineers.map((x: any) => x.open);
      const totalData  = engineers.map((x: any) => x.total);

      this.engineerChartData = {
        labels,
        datasets: [
          {
            label: 'Closed',
            data: closedData,
            backgroundColor: 'rgba(75, 192, 192, 0.8)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
          },
          {
            label: 'Total',
            data: totalData,
            backgroundColor: 'rgba(54, 162, 235, 0.8)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
          {
            label: 'Open',
            data: openData,
            backgroundColor:  '#16365C',
            borderColor:  '#16365C',
            borderWidth: 1,
          },
          
        ]
      };

    });
}


  loadDashboard(payload: any) {

  this.masterService.dashboardHierarchy(payload).subscribe({
    next: (res: any) => {

      this.metrics = {
        projects: res?.no_of_projects || 0,
        parts: res?.no_of_parts || 0,
        openProjects: res?.no_of_open_projects || 0,
        totalValue: this.formatIndianCurrency(res?.total_sourced_value)
      };

    },
    error: (err) => {
      console.error('Dashboard API error', err);
    }
  });

}
formatIndianCurrency(value: number | null | undefined): string {

  if (!value && value !== 0) {
    return '0';
  }

  return Math.round(value).toLocaleString('en-IN');
}
  loadAgeingSummary(payload: any) {
const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
const role = this.roleService.getUserRole();


const params: any = {
  manager_id: currentUser.manager_id ?? currentUser.user_id,
    // engineer_id: currentUser.engineer_id ,
};

// Add date filter parameters if set
if (this.ageingStartDate) {
  params['start_date'] = this.ageingStartDate;
}
if (this.ageingEndDate) {
  params['end_date'] = this.ageingEndDate;
}

console.log('Role based params =>', params);


this.masterService.getAgeingSummary(params).subscribe({
    next: (res: any) => {

      const ageing = res?.ageing;

      this.ageingChartData = {
        labels: ['0-5 Days', '6-8 Days', '9-10 Days', '>10 Days'],
        datasets: [
          {
            label: 'Ageing',
            data: [
              ageing?.['0_5_days'] || 0,
              ageing?.['6_8_days'] || 0,
              ageing?.['9_10_days'] || 0,
              ageing?.['gt_10_days'] || 0
            ],
            backgroundColor: 'rgba(54,162,235,0.8)',
            borderColor: '',
            borderWidth: 0
          }
        ]
      };

    },
    error: (err) => {
      console.error('Ageing summary API error', err);
    }
  });

}
showTopVendorFilter = false;
selectedTopN = 5;

toggleTopVendorFilter() {
  this.showTopVendorFilter = !this.showTopVendorFilter;
}
masterDataList: any[] = [];

loadMasterData() {

  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

  const payload: any = {
    manager_id: currentUser.manager_id ?? currentUser.user_id,
      // engineer_id: currentUser.engineer_id ,
    // top_n: 5
    
  };

  this.masterService.getTopSuppliers(payload)
    .subscribe((res: any) => {

      this.masterDataList = res?.suppliers || [];

    });
}

// loadImportStatus() {

//   const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

//   const payload: any = {
//     manager_id: currentUser.manager_id ?? currentUser.user_id,
//       // engineer_id: currentUser.engineer_id ,
//   };

//   this.masterService
//     .getImportStatusCommodityWise(payload)
//     .subscribe((res: any) => {

//       const list = res?.import_status || [];

//       const labels = list.map((x: any) => x.commodity);

//       const localData = list.map((x: any) =>
//         Number(x.local_cost || 0)
//       );

//       const importData = list.map((x: any) =>
//         Number(x.import_cost || 0)
//       );

//       this.importStatusData = {
//         labels: labels,
//         datasets: [
//           {
//             label: 'Local',
//             data: localData,
//             backgroundColor: 'rgba(255, 99, 132, 0.8)',
//             borderColor: 'rgba(255, 99, 132, 1)',
//             borderWidth: 1
//           },
//           {
//             label: 'Import',
//             data: importData,
//             backgroundColor: 'rgba(54, 162, 235, 0.8)',
//             borderColor: 'rgba(54, 162, 235, 1)',
//             borderWidth: 1
//           }
//         ]
//       };

//     });
// }

loadCompletionSummary() {

  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

  const payload: any = {
    manager_id: currentUser.manager_id  ?? currentUser.user_id ,
      // engineer_id: currentUser.engineer_id ,
   
  };

  // Add date filter parameters if set
  if (this.completionStartDate) {
    payload['start_date'] = this.completionStartDate;
  }
  if (this.completionEndDate) {
    payload['end_date'] = this.completionEndDate;
  }

  this.masterService
    .getCompletionSummary(payload)
    .subscribe((res: any) => {

      const completion = res?.completion;

      const data = [
        completion?.lt_50_percent ?? 0,   // < 50%
        completion?.['50_75_percent'] ?? 0, // 50–75%
        completion?.gt_75_percent ?? 0   // > 75%
      ];

      this.completionChartData = {
        labels: ['<50%', '50-75%', '>75%'],
        datasets: [
          {
            data,
            backgroundColor: [
                 '#16365C',
              '#538DD5',
              '#C5D9F1'
            ],
            borderColor: [
                '#16365C',
              '#538DD5',
              '#C5D9F1'
            ],
            borderWidth: 1,
          }
        ]
      };
      // Trigger change detection for chart re-render with new options
      this.completionChartData = { ...this.completionChartData };

    });
}


masterDataStatusList: any[] = [];

loadMasterDataStatus() {

  this.masterService.getMasterDataStatus().subscribe({
    next: (res: any) => {

      
      this.masterDataStatusList = res?.master_data_status || [];

    },
    error: () => {
      this.masterDataStatusList = [];
    }
  });

}
showPartDeviationTopFilter = false;
selectedPartDeviationTopN = 5;

togglePartDeviationTopFilter() {
  this.showPartDeviationTopFilter = !this.showPartDeviationTopFilter;
}
  partDeviationList: any[] = [];

loadPartPricingSummary() {

 
    const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

  const params: any = {
    manager_id: currentUser.manager_id ?? currentUser.user_id,
      // engineer_id: currentUser.engineer_id ,
    // engineer_id: currentUser.engineer_id ?? null,
    //  top_n: 5
     top_n: this.selectedPartDeviationTopN 
  };


  this.masterService.getPartPricing(params).subscribe({
    next: (res: any) => {

      this.partDeviationList = res?.parts || [];

    },
    error: () => {
      this.partDeviationList = [];
    }
  });
}

// ===== DATE FILTER PROPERTIES =====
showAgeingDateFilter = false;
showCostDateFilter = false;
showCompletionDateFilter = false;
showEngineerDateFilter = false;
showPartDeviationDateFilter = false;

ageingStartDate: string | null = null;
ageingEndDate: string | null = null;

costStartDate: string | null = null;
costEndDate: string | null = null;

completionStartDate: string | null = null;
completionEndDate: string | null = null;

engineerStartDate: string | null = null;
engineerEndDate: string | null = null;

partDeviationStartDate: string | null = null;
partDeviationEndDate: string | null = null;

// ===== DATE FILTER TOGGLE METHODS =====
toggleAgeingDateFilter() {
  this.showAgeingDateFilter = !this.showAgeingDateFilter;
}

cancelAgeingDateFilter() {
  this.ageingStartDate = null;
  this.ageingEndDate = null;
  this.showAgeingDateFilter = false;
  this.loadAgeingSummary({});
}

toggleCostDateFilter() {
  this.showCostDateFilter = !this.showCostDateFilter;
}

cancelCostDateFilter() {
  this.costStartDate = null;
  this.costEndDate = null;
  this.showCostDateFilter = false;
  this.loadDashboards({});
}

toggleCompletionDateFilter() {
  this.showCompletionDateFilter = !this.showCompletionDateFilter;
}

cancelCompletionDateFilter() {
  this.completionStartDate = null;
  this.completionEndDate = null;
  this.showCompletionDateFilter = false;
  this.loadCompletionSummary();
}

toggleEngineerDateFilter() {
  this.showEngineerDateFilter = !this.showEngineerDateFilter;
}

cancelEngineerDateFilter() {
  this.engineerStartDate = null;
  this.engineerEndDate = null;
  this.showEngineerDateFilter = false;
  this.loadDashboards({});
}

togglePartDeviationDateFilter() {
  this.showPartDeviationDateFilter = !this.showPartDeviationDateFilter;
}

cancelPartDeviationDateFilter() {
  this.partDeviationStartDate = null;
  this.partDeviationEndDate = null;
  this.showPartDeviationDateFilter = false;
  this.loadPartPricingSummary();
}
smartSyncSummary: any = null;

loadSmartSyncSummary() {

  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

  const params = {
       manager_id: currentUser.manager_id ?? currentUser.user_id,
  };

  this.masterService.getSmartSyncSummary(params).subscribe({
    next: (res: any) => {
      this.smartSyncSummary = res || null;
    },
    error: () => {
      this.smartSyncSummary = null;
    }
  });

}
loadSupplierPaymentSummary() {
  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
  const params = {
     manager_id: currentUser.manager_id ?? currentUser.user_id,
  };

  this.masterService.getSupplierPaymentSummary(params)
    .subscribe((res: any) => {

      const terms = res?.payment_terms || [];

      const labels: string[] = [];
      const data: number[] = [];

      terms.forEach((t: any) => {

        // empty / null payment term avoid cheyyali ante
        if (!t.payment_term) {
          return;
        }

        labels.push(t.payment_term);
        data.push(t.percentage);   // <-- important
      });

      this.costChartData = {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: this.generateColors(data.length),
            borderColor: this.generateColors(data.length),
            borderWidth: 1
          }
        ]
      };
      // Trigger change detection for chart re-render with new options
      this.costChartData = { ...this.costChartData };

    });
}
generateColors(count: number): string[] {

  const base = [
    'rgba(54, 162, 235, 0.8)',
    '#16365C',
    '#538DD5',
    '#C5D9F1',
    'rgba(153, 102, 255, 0.8)',
    'rgba(255, 205, 86, 0.8)'
  ];

  const colors: string[] = [];

  for (let i = 0; i < count; i++) {
    colors.push(base[i % base.length]);
  }

  return colors;
}
costSavingsList: any[] = [];

loadCostSavings() {
  const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
  const params = {
          manager_id: currentUser.manager_id ?? currentUser.user_id,
    top_n: 5
  };

  this.masterService.getCostSavings(params).subscribe({
    next: (res: any[]) => {
      this.costSavingsList = res || [];
    },
    error: () => {
      this.costSavingsList = [];
    }
  });

}
}